import React, { ReactNode } from "react";

interface PublicRoutesProps {
  children: ReactNode;
}

const PublicRoutes: React.FC<PublicRoutesProps> = ({ children }) => {
  return <>{children}</>;
};

export default PublicRoutes;
